/* eslint-disable */
import { useParameter, useExport } from "../../../shared";
import * as React from "react";
import { REPORT_ID } from "../constants";

export function useExportQuery(title, subtitle) {
  const exportBuilder = useExport();
  const [commodities] = useParameter<number[]>("@commodities");
  const [commodities_groups] = useParameter<number[]>("@commodities_groups");
  const [business] = useParameter<number>("@business-units");
  const [calendar] = useParameter<number>("@calendar");
  const [e_commodities] = useParameter<number[]>("@e_commodities");
  const [e_countries] = useParameter<number[]>("@e_countries");

  React.useEffect(() => {
    exportBuilder.set('title', title);
    exportBuilder.set('subtitle', subtitle);
    exportBuilder.set('reportDefinition', {
      reportId: exportBuilder.reportId,
      name: { 9: title },
      parameters: {
        "@business-units": business && String(business),
        "@commodities": commodities && commodities.map(String),
        "@commodities_groups": commodities_groups && commodities_groups.map(String),
        "@calendar": String(calendar),
        "@e_calendar": [-1, 0].map(x => (calendar || 0) + (x * 10000)).map(String),
        "@e_commodities": e_commodities && e_commodities.map(String),
        "@e_countries": e_countries && e_countries.map(String),
      }
    }); 
  }, [exportBuilder, calendar, commodities, commodities_groups, e_countries, e_commodities, business]);
}

